<template>
  <div class="radar-chart">
    <div class="student-pie" :style="widthStyle()">
      <div class="list-view-btop" :style="widthStyle()">
        <div class="stuPieDomDiv" :class="isNationwide ? 'stuPieDomDiv2' : ''" :style="widthStyle()">
          <div ref="stuPieDom" v-if="isShow" class="stuPieDom" :style="widthStyle()"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入 echarts 核心模块，核心模块提供了 echarts  使用必须要的接口。
import * as echarts from 'echarts'
export default {
  name: 'RadarChart',
  data () {
    return {
      myChart: {},
      isShow: true,
      detail: {},
      option: {}
    }
  },
  props: {
    initData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    titlePosition: {
      type: String || Number,
      default: 'center'
    },
    // 是否是全国  true为全国 false为全省
    isNationwide: {
      type: Boolean,
      default: false
    },
    activeTxt: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: ''
    },
  },
  watch: {
    initData: {
      handler (newValue, oldValue) {
        if (newValue) {
          this.detail = { ...newValue }
          this.createRadar()
        }
      },
      deep: true // 深度监听
      //   immediate: true
    }
  },
  methods: {
    widthStyle () {
      return {width: this.width}
    },
    createRadar () {
      this.$nextTick(() => {
        let stuPieDom = this.$refs.stuPieDom
        let myChart = echarts.init(stuPieDom)
        this.myChart = myChart
        this.initOption(stuPieDom.clientWidth)
        myChart.setOption(this.option)
      })
    },
    initOption (divWidth) {
      this.option = {
        color: ['#EC3636'],
        radar: {
          axisLine: {
            show: false
          },
          splitNumber: 6,
          center: ['50%', '50%'],
          name: {
            // 统一设置颜色字体
            textStyle: {
              color: '#5B5F6A',
              fontSize: 12,
              align: 'center',
              padding: [-36, 0]
            }
          },
          nameGap: 40,
          splitArea: {
            areaStyle: {
              color: 'rgba(0,0,0,0)',
              opacity: 1
            }
          },
          radius: divWidth / 3.81,
          indicator: [
            { name: 'FOT\n（稳定贴靠）', max: 6 },
            { name: '碎点\n（穿刺位置）', max: 6 },
            { name: '手术时间\n（高效消融）', max: 6 },
            { name: '放电时间占比\n(鞘管微调)', max: 6 },
            { name: 'Gap\n（逐点连续）', max: 6 },
            { name: 'AI\n（前庭消融）', max: 6 }
          ]
        },
        series: [
          {
            type: 'radar',
            symbolSize: 0,
            data: [
              {
                value: [this.detail.aifv4, this.detail.aifv2, this.detail.aifv3, this.detail.aifv6, this.detail.aifv1, this.detail.aifv5],
                name: 'AIFV',
                areaStyle: {
                  opacity: 0.3
                },
                lineStyle: {
                  type: 'solid',
                  width: 2
                }
              }
            ]
          }
        ]
      }
    }
  },
  mounted () {
    if (Object.keys(this.initData).length <= 0) {
      this.detail = {
        aifv1: 0,
        aifv2: 0,
        aifv3: 0,
        aifv4: 0,
        aifv5: 0,
        aifv6: 0
      }
    } else {
      this.detail = { ...this.initData }
    }
    this.createRadar()
  },
  beforeDestroy () {
    if (this.myChart && typeof this.myChart.dispose === 'function') {
      this.myChart.dispose()
    }
  }
}
</script>

<style lang="less" scoped>
.radar-chart {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  position: relative;
  padding-bottom: 12px;
  box-sizing: border-box;
  //   justify-content: center;
}

.student-pie {
  width: 351px;
  max-width: 100%;
  overflow-x: hidden;
  background-color: #f0f1f6;
  display: flex;
  flex-wrap: wrap;

  .list-view-btop {
    background: #ffffff;
    box-shadow: 2px 3px 10px 0 rgba(0, 0, 0, 0.04);
    border-radius: 5px;
    .stuPieDomDiv {
      width: 351px;
      height: 300px;
      background: #ffffff;

      &.stuPieDomDiv2 {
        width: 335px;
        height: 300px;

        .stuPieDom {
          width: 335px;
          height: 300px;
        }
      }

      .stuPieDom {
        width: 351px;
        height: 300px;
        text-align: center;
        background: #ffffff;
        border-radius: 5px;
      }
    }
  }

  .list-table {
    background-color: #fff;
    margin-top: 8px;
    padding: 0 6px;
    box-sizing: border-box;
    width: 100%;

    .tilte-txt {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #2b2b2b;
      font-weight: 600;
      height: 60px;

      .num {
        font-size: 22px;
        color: #2b2b2b;
        font-weight: bold;
        margin-left: 10px;
      }
    }

    .table-tr {
      display: flex;
      align-items: center;
      height: 32px;
      padding-left: 10px;
      box-sizing: border-box;
      margin-bottom: 12px;
      justify-content: space-between;

      &.th {
        background-color: #f0f1f6;
      }

      &.tr {
        height: 14px;
        line-height: 14px;
        margin-bottom: 16px;
      }

      .table-td {
        font-size: 10px;
        color: #2b2b2b;
        font-weight: 400;
        width: 25%;

        &:nth-last-child(1) {
          width: 50px;
        }

        &.table-th {
          font-size: 12px;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/kdSimulator/components/RadarChart.vue